import { IconButton, Modal,ContextualMenu,mergeStyleSets, PrimaryButton, DefaultButton, Spinner, SpinnerSize } from "@fluentui/react";
import React, { useEffect, useState,useContext } from "react";
import $ from "jquery";
import "./modalStyles.css";
import { ErrorIcon } from "@fluentui/react-icons-mdl2";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import { logAmplitudeEventWithUsernameAndRole } from "../../helpers/Amplitude";
import userContext from "../../context/users/UserContext";
import { CUSTOM_STYLES } from "../../constants/Constants";
import ModalHeader from "../Modal/ModalHeader";
import ModalFooter from "../Modal/ModalFooter";
import { t } from "i18next";
import ModalMain from "../Modal/ModalMain";
import themeContext from "../../context/theme/ThemeContext";

const ConfirmAlertModal = (props) => {

  const {isConflictSave,setConflictSave,setPassConflict,setShowAddendumDisclaimerPopup} = useContext(studyReportContext);
  const {username} = useContext(userContext);
  const { getThemeColor} = useContext(themeContext);
   
    const handleConflictSave = () => {
      // console.log("---- Running HandleConflictSave ---");
      setConflictSave("0"); 
      setPassConflict(true);

      let eventProperties = {};
      logAmplitudeEventWithUsernameAndRole('EVENT_BASIC_GENDER_CONFLICT_TOOL_USED',eventProperties, username);

      props.checkIfCancelOrNot(false,props.keyImages,props.annotationData,props.annotationDataAI,props.allTextToolAnnotation,props.activeViewportIndex,true, props.qcData);         
    }

    let DefaultButtonList = [
      {
        title: props.type != undefined && props.type != null && (props.type == "lock" || props.type == "resubmit")?t("button.no"):t("button.cancel"),
        onclick: ()=>{setPassConflict(null);setConflictSave("0");setShowAddendumDisclaimerPopup(true);props.hideModal()},
      },
    ];

    let PrimaryButtonList = [
      {
          title: props.type != undefined && props.type != null && (props.type == "lock" || props.type == "resubmit")?t("button.yes"):t("button.continue"),
          onclick: ()=>{
            props.isConflictPopup != undefined && props.isConflictPopup == true ?
            handleConflictSave()     
          :
            (props.type=="save" || props.type=="submit" || props.type=="resubmit")?
            props.checkIfCancelOrNot(false,props.keyImages,props.annotationData,props.annotationDataAI,props.allTextToolAnnotation,props.activeViewportIndex,true):
            props.lockStudy(true,props.assignmentData)}
      }
  ]

    const modalDetails = {
      header: (
        <ModalHeader
          updatedModal={true}
          heading={props.heading}
          handleCancel={props.hideModal}
        />
      ),
      body: <div className="global-modal-body" style={{color:getThemeColor("primary-color")}}>{props.description}</div>,
      footer: <ModalFooter PrimaryButtonList={PrimaryButtonList} DefaultButtonList={DefaultButtonList} />,
      width: "500px",
    };

    return (
      <ModalMain
        updatedModal={true}
        modalDetails={modalDetails}
        showModal={true}
      />
    )
}

export default ConfirmAlertModal;